import React from "react";

import CustomerInformation from "./screens/CustomerInformation";
import OrderInformation from "./screens/OrderInformation";
import InsuranceProfile from "./screens/InsuranceProfile";
import VehicleCheckin from "./screens/VehicleCheckin";
import VehicleCondition from "./screens/VehicleCondition";
import VehicleDentInfo from "./screens/VehicleDentInfo";
import VehicleDentInfo3D from "./screens/VehicleDentInfo3D";
import VehicleDentInfo3DNew from "./screens/VehicleDentInfo3DNew/index";
import TabView from "./screens/TabView";
import ReportMini from "./screens/ReportMini";
import ReportMiniROM from "./screens/ReportMiniROM";
import ReportFull from "./screens/ReportFull";
import PartDetails from "./screens/PartDetails";
import NewPartDetails from "./screens/NewPartDetails";
import QrList from "./views/Dashboard/Qr";
import ScanList from "./views/Dashboard/ScanList";
import CreateQr from "./screens/CreateQr";
import NewCreateQr from "./screens/NewCreateQr";
import CreateVinRecord from "./views/Dashboard/CreateVin";
import Image from "./views/Dashboard/ImageEditor";
import AppInterface from './views/Dashboard/AppInterface'
import CartecReport from "./screens/CartecReport";
import TabViewDNS from "./screens/TabViewDNS";
import ReportMiniDNS from "./screens/ReportMiniDNS";
import ReportFullDNS from "./screens/ReportFullDNS";
import ReportImages from "./screens/Images";
import DAT from "./views/Dashboard/DAT";
import TabViewSL from "./screens/TabViewSL";
import Clients from "./screens/Clients";
import Profile from "./containers/DefaultLayout/profile/Profile";
import ReportFullROM from "./screens/ReportFullROM";
import TabViewROM from "./screens/TabViewROM";
import AllScanRecords from "./screens/AllScanRecords";
import ViewQr from "./views/Dashboard/ViewQR";
import ViewQrAfter from "./views/Dashboard/ViewQrAfter";
import Notes from "./screens/Notes";
import NewTabviewSwiss from "./screens/NewTabviewSwiss";
import NewReportFull from "./screens/NewReportFull";
import TabViewCZ from "./screens/TabViewCZ";
import ReportMiniCZ from "./screens/ReportMiniCZ";
import ReportFullCZ from "./screens/ReportFullCZ";
import SoftwareGuide from "./screens/SoftwareGuide";
import OtherDnsApp from "./screens/OtherDnsApp";
import HardwareAssembly from "./screens/HardwareAssembly";
import UserManual from "./screens/UserManual";
import NewReportMiniSwiss from "./screens/NewReportMiniSwiss";
import DentEditor from "./views/Dashboard/DentEditor";
import OldQR from "./views/Dashboard/OldQR";
import MarkersPositioning from "./screens/MarkersPositioning";
import TabViewSwissFrench from "./screens/TabViewSwissFrench";
import ReportMiniFrench from "./screens/ReportMiniFrench";
import ReportFullFrench from "./screens/ReportFullFrench";
import MobileApp from './screens/MobileApp';
import SwissDATReport from "./screens/SwissDATReport";
import PictureGallery from "./screens/PictureGallery";
import UpdateLang from "./screens/common/updateLang/UpdateLang";
import TabViewAUT from "./screens/reportsAUT/TabViewAUT";
import ReportMiniAUT from "./screens/reportsAUT/ReportMiniAUT";
import ReportFullAUT from "./screens/reportsAUT/ReportFullAUT";
import ReportMiniFrench2 from "./screens/ReportMiniFrench2";
import ReportFullFrench2 from "./screens/ReportFullFrench2";
import PreDamage from "./screens/PreDamage";
import Statistics from "./screens/Statistics";
import DetailedReport from "./screens/DetailedReport";
import UserCreation from "./containers/DefaultLayout/UserCreation"
import TabViewUS from "./screens/TabViewUS";
import AmericanReportFull from "./screens/AmericanReportFull";
import ReportMiniUS from "./screens/ReportMiniUS";
import ReportMiniEU from "./screens/ReportMiniEU";
import ReportFullUS from "./screens/ReportFullUS";
import TabViewCanada from "./screens/TabViewCanada";
import ReportMiniCanada from "./screens/ReportMiniCanada";
import ReportFullCanada from "./screens/ReportFullCanada";
import ReportMiniEUCanada from "./screens/ReportMiniEUCanada";
import AmericanReportFullCanada from "./screens/AmericanReportFullCanada";
import ReportFullGeneralDamageImage from "./screens/ReportFullGeneralDamageImage";
import NewQr from "./views/Dashboard/NewQr";
import TabviewPoland from "./screens/TabviewPoland";
import PolandReportMini from "./screens/PolandReportMini";
import PolandReportFull from "./screens/PolandReportFull";
import mobileUser from "./containers/DefaultLayout/profile/mobileUser";
import emailAuthorized from "./containers/DefaultLayout/profile/emailAuthorized";
import DatCredentials from "./containers/DefaultLayout/profile/datCredentials";
import InsuranceManagement from "./containers/DefaultLayout/InsuranceManagement";
// import PolandExtraPage from "./screens/common/polandExtraPage/PolandExtraPage";
const Dashboard = React.lazy(() => import("./views/Dashboard"));

let routes = [
  {
    path: "/",
    exact: true,
    name: "Home"
  },
  { 
    path: "/dashboard",
    exact: true,
    name: "Dashboard",
    component: Dashboard
  },
  { 
    path: "/profile",
    exact: true,
    name: "Profile",
    component: Profile
  },
  {
    path: "/ViewQR",
    exact: true,
    name: "View QR",
    component: ViewQr,
  },
  {
    path: "/NewQR",
    exact: true,
    name: "New QR",
    component: NewQr,
  },
  {
    path: "/OldQR",
    exact: true,
    name: "Old QR",
    component: OldQR,
  },
  {
    path: "/appInterFace",
    exact: true,
    name: "App Interface",
    component: AppInterface,
  },
  {
    path: "/dnsMobileApp",
    exact: true,
    name: "App Interface",
    component: MobileApp,
  },
  {
    path: "/ViewQrAfter",
    exact: true,
    name: "View QR After",
    component: ViewQrAfter,
  },
  { path: "/DAT", exact: true, name: "DAT", component: DAT },
  {
    path: "/customer-info",
    name: "CustomerInformation",
    component: CustomerInformation,
  },
  { path: "/clients", name: "Clients", component: Clients },
  { path: "/order", name: "Order", component: OrderInformation },
  {
    path: "/InsuranceProfile",
    name: "Insurance Profile",
    component: InsuranceProfile,
  },
  {
    path: "/VehicleCheckin",
    name: "Vehicle Check in",
    component: VehicleCheckin,
  },
  {
    path: "/VehicleCondition",
    name: "Vehicle Condition",
    component: VehicleCondition,
  },
  {
    path: "/vehicleDentInfo",
    name: "Vehicle Dent Information",
    component: VehicleDentInfo,
  },
  {
    path: "/vehicleDentInfo3D",
    name: "Vehicle Dent Information 3D",
    component: VehicleDentInfo3D,
  },
  {
    path: "/vehicleDentInfo3DNew",
    name: "Vehicle Dent Information 3D",
    component: VehicleDentInfo3DNew,
  },
  { path: "/TabView", name: "Tab View", exact: true, component: TabView },
  { path: "/TabViewDNS", name: "Tab View", component: TabViewDNS },
  {
    path: "/ReportMini",
    exact: true,
    name: "Mini Report",
    component: ReportMini,
  },
  { path: "/ReportMiniDNS", name: "Mini Report", component: ReportMiniDNS },

  { path: "/ExtraImages/:vin", name: "Extra Images", component: ReportImages },
  { path: "/ImageEditor", name: " ImageEditor", component: Image },
  { path: "/dentEditor", name: "Dents Editor", component: DentEditor },

  { path: "/PartDetails", name: "Part Details", component: PartDetails },
  { path: "/NewPartDetails", name: "New Part Details", component: NewPartDetails },
  { path: "/qrlist", exact: true, name: "QR List", component: QrList },
  { path: "/ScanList", exact: true, name: "Scan List", component: ScanList },

  { path: "/createQR", name: "Create QR", component: CreateQr },
  { path: "/newCreateQR", name: "New Create QR", component: NewCreateQr },
  { path: "/CreateVin", name: "Create VIN", component: CreateVinRecord },

  {
    path: "/cartecReport",
    exact: true,
    name: "Report",
    component: CartecReport,
  },

  {
    path: "/ReportFull",
    name: "Full Report",
    exact: true,
    component: ReportFull,
  },
  { path: "/ReportFullDNS", name: "Full Report", component: ReportFullDNS },
  { path: "/ReportFullGeneralDamageImage", name: "GeneralDamage Full Report", component: ReportFullGeneralDamageImage },
  {
    path: "/TabView/slovani",
    exact: true,
    name: "Tab View",
    component: TabViewSL,
  },
  {
    path: "/ReportMini/slovani",
    exact: true,
    name: "Mini Report",
    component: ReportMini,
  },
  {
    path: "/ReportFull/slovani",
    name: "Full Report",
    exact: true,
    component: ReportFull,
  },

  {
    path: "/TabView/romania",
    exact: true,
    name: "Tab View",
    component: TabViewROM,
  },
  {
    path: "/ReportMini/romania",
    exact: true,
    name: "Mini Report",
    component: ReportMiniROM,
  },
  {
    path: "/ReportFull/romania",
    name: "Full Report",
    exact: true,
    component: ReportFullROM,
  },
  {
    path: "/AllScanRecords",
    name: "All Scan Records",
    exact: true,
    component: AllScanRecords,
  },
  {
    path: "/UpdateLang",
    name: "Update Lang",
    exact: true,
    component: UpdateLang,
  },
  {
    path: "/Statistics",
    name: "Statistics",
    exact: true,
    component: Statistics,
  },
  {
    path: "/Notes",
    name: "Notes",
    exact: true,
    component: Notes,
    // component: Notes,
  },
  // SWiss new Tabview
  {
    path: "/NewTabview",
    name: "Tab view Swiss",
    exact: true,
    component: NewTabviewSwiss,
  },
  {
    path: "/NewReportMini",
    name: "Report Mini Swiss",
    exact: true,
    component: NewReportMiniSwiss,
  },
  {
    path: "/NewReportFull",
    name: "Report Full Swiss",
    exact: true,
    component: NewReportFull,
  },
  {
    path: "/DATswiss",
    name: "DAT Report",
    exact: true,
    component: SwissDATReport,
  },

  // Poland new Tabview
  {
    path: "/PolandTabview",
    name: "Tab view Poland",
    exact: true,
    component: TabviewPoland,
  },
  {
    path: "/PolandReportMini",
    name: "Report Mini Poland",
    exact: true,
    component: PolandReportMini,
  },
  {
    path: "/PolandReportFull",
    name: "Report Full Poland",
    exact: true,
    component: PolandReportFull,
  },

  // Czech Republic 
  {
    path: "/TabViewCZ",
    name: "Tab View",
    exact: true,
    component: TabViewCZ,
  },
  {
    path: "/ReportMiniCZ",
    name: "Mini Report",
    exact: true,
    component: ReportMiniCZ,
  },
  {
    path: "/ReportFullCZ",
    name: "Full Report",
    exact: true,
    component: ReportFullCZ,
  },
  {
    path: "/SoftwareGuide",
    name: "Software Guide",
    exact: true,
    component: SoftwareGuide,
  },
  {
    path: "/HardwareAssembly",
    name: "Hardware Assembly",
    exact: true,
    component: HardwareAssembly,
  },
  {
    path: "/UserManual",
    name: "Help",
    exact: true,
    component: UserManual,
  },
  {
    path: "/Marker",
    name: "MarkersPositioning",
    component: MarkersPositioning
  },
  {
    path: "/plannerApp",
    name: "Planner App",
    exact: true,
    component: OtherDnsApp,
  },
  {
    path: "/workshopApp",
    name: "Workshop App",
    exact: true,
    component: OtherDnsApp,
  },
  // French 
  {
    path: "/TabViewSwissFrench",
    name: "Tab view Swiss",
    exact: true,
    component: TabViewSwissFrench,
  },
  {
    path: "/ReportMiniSwissFrench",
    name: "Report Mini SWISS",
    exact: true,
    component: ReportMiniFrench,
  },
  {
    path: "/ReportFullSwissFrench",
    name: "Report Full SWISS",
    exact: true,
    component: ReportFullFrench,
  },
  {
    path: "/ReportMiniSwissFrench-2",
    name: "Report Mini SWISS",
    exact: true,
    component: ReportMiniFrench2,
  },
  {
    path: "/ReportFullSwissFrench-2",
    name: "Report Full SWISS",
    exact: true,
    component: ReportFullFrench2,
  },
  {
    path: "/gallery",
    name: "Picture Gallery",
    exact: true,
    component: PictureGallery,
  },

  // AUT client
  {
    path: '/tabviewAUT',
    name: 'Tab View Austria',
    exact: true,
    component: TabViewAUT
  },
  {
    path: '/reportMiniAUT',
    name: 'Mini Report Austria',
    exact: true,
    component: ReportMiniAUT
  },
  {
    path: '/reportFullAUT',
    name: 'Full Report Austria',
    exact: true,
    component: ReportFullAUT
  },
  {
    path: "/PreDamage",
    name: "Pre Damage Swiss",
    exact: true,
    component: PreDamage,
  },
  {
    path: "/DetailedReport",
    name: "Detailed Report",
    exact: true,
    component: DetailedReport
  },
  {
    path: "/UserCreation",
    name: "User Creation",
    exact: true,
    component: UserCreation
  },
  {
    path: "/insuranceManagement",
    name: "Insurance Management",
    exact: true,
    component: InsuranceManagement
  },
  {
    path: "/mobileUser",
    name: "mobileUser",
    exact: true,
    component: mobileUser
  },
  {
    path: "/emailAuthorized",
    name: "EmailAuthorized",
    exact: true,
    component: emailAuthorized
  },
  {
    path: "/datCredentials",
    name: "DAT Credentials",
    exact: true,
    component: DatCredentials
  },
  /* US reports */
  {
    path: "/TabViewUS",
    name: "Tab View",
    exact: true,
    component: TabViewUS,
  },
  {
    path: "/ReportMiniUS",
    name: "Report Mini US",
    exact: true,
    component: ReportMiniUS,
  },
  {
    path: "/ReportMiniEU_1",
    name: "Report Mini EU",
    exact: true,
    component: ReportMiniEU,
  },
  {
    path: "/ReportFullUS",
    name: "Report Full US",
    exact: true,
    component: ReportFullUS,
  },
  {
    path: "/AmericanReport",
    name: "Report Full American",
    exact: true,
    component: AmericanReportFull,
  },
  /* CANADA Reports  */
  {
    path: "/Canada/TabView",
    name: "Tab View",
    exact: true,
    component: TabViewCanada,
  },
  {
    path: "/Canada/ReportMini",
    name: "Report Mini Canada",
    exact: true,
    component: ReportMiniCanada,
  },
  {
    path: "/Canada/ReportFullCA",
    name: "Report Full Canada",
    exact: true,
    component: ReportFullCanada,
  },
  {
    path: "/Canada/ReportMiniCA",
    name: "Report Mini CA",
    exact: true,
    component: ReportMiniEUCanada,
  },
  {
    path: "/Canada/AmericanReport",
    name: "Report Full American",
    exact: true,
    component: AmericanReportFullCanada,
  },
];

export default routes;